import React, { ReactNode, useState } from "react";
import { Button, Collapse } from "react-bootstrap";
import { Icon, InfoPopover } from "src/components";

type AllProps = {
  title: string;
  children?: ReactNode;
  popover?: string;
  refresh?: Function;
  isLoading?: boolean;
  className?: string;
  default_open?: boolean
};

function CollapseWrapperComponent(props: AllProps) {
  const { default_open, children, title, popover, refresh, isLoading, className } = props;
  const [open, setOpen] = useState<boolean>(!!default_open);

  return (
    <div className={`collapse-section ${!!className ? className : ""}`}>
      <h5>
        {title}
        {!!popover ? <InfoPopover message={popover} /> : null}
        <span className={`ms-auto${!!refresh ? " refresh" : ""}`}>
          {!!refresh && (
            <Button variant="icon" size="sm" onClick={() => refresh()} aria-label="Refresh">
              {isLoading ? <i className="spinner"></i> : <Icon className="ficon-rotate-cw" />}
            </Button>
          )}
          <Button
            aria-label="Toggle Collapse"
            onClick={() => setOpen(!open)}
            tabIndex={-1}
            className="toggle-btn"
            variant="icon"
          >
            {!!open ? (
              <Icon className="ficon-chevron-up m-0" />
            ) : (
              <Icon className="ficon-chevron-down m-0" />
            )}
          </Button>
        </span>
      </h5>
      <Collapse in={open}>
        <div>{children}</div>
      </Collapse>
    </div>
  );
}

export default CollapseWrapperComponent;
